import type { IStyleDto_Props } from './StyleDto.if';
import type IStyleDto from './StyleDto.if';
import type IFontSizeUnitDto from './FontSizeUnitDto.if';
import type IMediumDto from './MediumDto.if';
import type IBackgroundModeDto from './BackgroundModeDto.if';
import type IFontFamilyDto from './FontFamilyDto.if';
import type IFontStyleDto from './FontStyleDto.if';
import type IFontAlignmentDto from './FontAlignmentDto.if';
import type ISiteDto from './SiteDto.if';
import type { IModelSource } from '../interface/db';

export interface IStyleDto_Linkables {
    parent: (db: IModelSource) => Promise<IStyleDto>;
    site: (db: IModelSource) => Promise<ISiteDto>;
    foregroundImageMedium: (db: IModelSource) => Promise<IMediumDto>;
    backgroundImageMedium: (db: IModelSource) => Promise<IMediumDto>;
    menuImageMedium: (db: IModelSource) => Promise<IMediumDto>;
    backgroundMode: (db: IModelSource) => Promise<IBackgroundModeDto>;
    primaryFontFamily: (db: IModelSource) => Promise<IFontFamilyDto>;
    primaryFontStyle: (db: IModelSource) => Promise<IFontStyleDto>;
    primaryFontSizeUnit: (db: IModelSource) => Promise<IFontSizeUnitDto>;
    primaryFontAlignment: (db: IModelSource) => Promise<IFontAlignmentDto>;
    secondaryFontFamily: (db: IModelSource) => Promise<IFontFamilyDto>;
    secondaryFontStyle: (db: IModelSource) => Promise<IFontStyleDto>;
    secondaryFontSizeUnit: (db: IModelSource) => Promise<IFontSizeUnitDto>;
    secondaryFontAlignment: (db: IModelSource) => Promise<IFontAlignmentDto>;
    tertiaryFontFamily: (db: IModelSource) => Promise<IFontFamilyDto>;
    tertiaryFontStyle: (db: IModelSource) => Promise<IFontStyleDto>;
    tertiaryFontSizeUnit: (db: IModelSource) => Promise<IFontSizeUnitDto>;
    tertiaryFontAlignment: (db: IModelSource) => Promise<IFontAlignmentDto>;
}

function _parent(this: Partial<IStyleDto_Props>, db: IModelSource): Promise<IStyleDto> {
    return this.parentId
        ? db.get('IStyleDto', this.parentId)
        : Promise.reject('Missing field style.parentId');
}

function _site(this: Partial<IStyleDto_Props>, db: IModelSource): Promise<ISiteDto> {
    return this.siteId
        ? db.get('ISiteDto', this.siteId)
        : Promise.reject('Missing field style.siteId');
}

function _foregroundImageMedium(
    this: Partial<IStyleDto_Props>,
    db: IModelSource,
): Promise<IMediumDto> {
    return this.foregroundImageMediumId
        ? db.get('IMediumDto', this.foregroundImageMediumId)
        : Promise.reject('Missing field style.foregroundImageMediumId');
}

function _backgroundImageMedium(
    this: Partial<IStyleDto_Props>,
    db: IModelSource,
): Promise<IMediumDto> {
    return this.backgroundImageMediumId
        ? db.get('IMediumDto', this.backgroundImageMediumId)
        : Promise.reject('Missing field style.backgroundImageMediumId');
}

function _menuImageMedium(this: Partial<IStyleDto_Props>, db: IModelSource): Promise<IMediumDto> {
    return this.menuImageMediumId
        ? db.get('IMediumDto', this.menuImageMediumId)
        : Promise.reject('Missing field style.menuImageMediumId');
}

function _backgroundMode(
    this: Partial<IStyleDto_Props>,
    db: IModelSource,
): Promise<IBackgroundModeDto> {
    return this.backgroundModeId
        ? db.get('IBackgroundModeDto', this.backgroundModeId)
        : Promise.reject('Missing field style.backgroundModeId');
}

function _primaryFontFamily(
    this: Partial<IStyleDto_Props>,
    db: IModelSource,
): Promise<IFontFamilyDto> {
    return this.primaryFontFamilyId
        ? db.get('IFontFamilyDto', this.primaryFontFamilyId)
        : Promise.reject('Missing field style.primaryFontFamilyId');
}

function _primaryFontStyle(
    this: Partial<IStyleDto_Props>,
    db: IModelSource,
): Promise<IFontStyleDto> {
    return this.primaryFontStyleId
        ? db.get('IFontStyleDto', this.primaryFontStyleId)
        : Promise.reject('Missing field style.primaryFontStyleId');
}

function _primaryFontSizeUnit(
    this: Partial<IStyleDto_Props>,
    db: IModelSource,
): Promise<IFontSizeUnitDto> {
    return this.primaryFontSizeUnitId
        ? db.get('IFontSizeUnitDto', this.primaryFontSizeUnitId)
        : Promise.reject('Missing field style.primaryFontSizeUnitId');
}

function _primaryFontAlignment(
    this: Partial<IStyleDto_Props>,
    db: IModelSource,
): Promise<IFontAlignmentDto> {
    return this.primaryFontAlignmentId
        ? db.get('IFontAlignmentDto', this.primaryFontAlignmentId)
        : Promise.reject('Missing field style.primaryFontAlignmentId');
}

function _secondaryFontFamily(
    this: Partial<IStyleDto_Props>,
    db: IModelSource,
): Promise<IFontFamilyDto> {
    return this.secondaryFontFamilyId
        ? db.get('IFontFamilyDto', this.secondaryFontFamilyId)
        : Promise.reject('Missing field style.secondaryFontFamilyId');
}

function _secondaryFontStyle(
    this: Partial<IStyleDto_Props>,
    db: IModelSource,
): Promise<IFontStyleDto> {
    return this.secondaryFontStyleId
        ? db.get('IFontStyleDto', this.secondaryFontStyleId)
        : Promise.reject('Missing field style.secondaryFontStyleId');
}

function _secondaryFontSizeUnit(
    this: Partial<IStyleDto_Props>,
    db: IModelSource,
): Promise<IFontSizeUnitDto> {
    return this.secondaryFontSizeUnitId
        ? db.get('IFontSizeUnitDto', this.secondaryFontSizeUnitId)
        : Promise.reject('Missing field style.secondaryFontSizeUnitId');
}

function _secondaryFontAlignment(
    this: Partial<IStyleDto_Props>,
    db: IModelSource,
): Promise<IFontAlignmentDto> {
    return this.secondaryFontAlignmentId
        ? db.get('IFontAlignmentDto', this.secondaryFontAlignmentId)
        : Promise.reject('Missing field style.secondaryFontAlignmentId');
}

function _tertiaryFontFamily(
    this: Partial<IStyleDto_Props>,
    db: IModelSource,
): Promise<IFontFamilyDto> {
    return this.tertiaryFontFamilyId
        ? db.get('IFontFamilyDto', this.tertiaryFontFamilyId)
        : Promise.reject('Missing field style.tertiaryFontFamilyId');
}

function _tertiaryFontStyle(
    this: Partial<IStyleDto_Props>,
    db: IModelSource,
): Promise<IFontStyleDto> {
    return this.tertiaryFontStyleId
        ? db.get('IFontStyleDto', this.tertiaryFontStyleId)
        : Promise.reject('Missing field style.tertiaryFontStyleId');
}

function _tertiaryFontSizeUnit(
    this: Partial<IStyleDto_Props>,
    db: IModelSource,
): Promise<IFontSizeUnitDto> {
    return this.tertiaryFontSizeUnitId
        ? db.get('IFontSizeUnitDto', this.tertiaryFontSizeUnitId)
        : Promise.reject('Missing field style.tertiaryFontSizeUnitId');
}

function _tertiaryFontAlignment(
    this: Partial<IStyleDto_Props>,
    db: IModelSource,
): Promise<IFontAlignmentDto> {
    return this.tertiaryFontAlignmentId
        ? db.get('IFontAlignmentDto', this.tertiaryFontAlignmentId)
        : Promise.reject('Missing field style.tertiaryFontAlignmentId');
}

/** 
 * @description all custom properties for
   StyleDto & methods to link against other entities
*/
function linkables(model: Partial<IStyleDto_Props>): IStyleDto_Linkables {
    return {
        parent: _parent.bind(model),
        site: _site.bind(model),
        foregroundImageMedium: _foregroundImageMedium.bind(model),
        backgroundImageMedium: _backgroundImageMedium.bind(model),
        menuImageMedium: _menuImageMedium.bind(model),
        backgroundMode: _backgroundMode.bind(model),
        primaryFontFamily: _primaryFontFamily.bind(model),
        primaryFontStyle: _primaryFontStyle.bind(model),
        primaryFontSizeUnit: _primaryFontSizeUnit.bind(model),
        primaryFontAlignment: _primaryFontAlignment.bind(model),
        secondaryFontFamily: _secondaryFontFamily.bind(model),
        secondaryFontStyle: _secondaryFontStyle.bind(model),
        secondaryFontSizeUnit: _secondaryFontSizeUnit.bind(model),
        secondaryFontAlignment: _secondaryFontAlignment.bind(model),
        tertiaryFontFamily: _tertiaryFontFamily.bind(model),
        tertiaryFontStyle: _tertiaryFontStyle.bind(model),
        tertiaryFontSizeUnit: _tertiaryFontSizeUnit.bind(model),
        tertiaryFontAlignment: _tertiaryFontAlignment.bind(model),
    };
}

export default linkables;
